// extracted by mini-css-extract-plugin
export default {"title":"styles_title__xSt8+","menu":"styles_menu__XsXxz"};